export default __webpack_public_path__ + "static/media/feraye4.1ba23ab5.jpg";